import { Component, Input, OnInit } from '@angular/core';
import { FrontEndMapping } from '../../../../core/configuration/front-end-mapping';
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { PraticaBase } from '../../../models/pratica/pratica-base';

@Component({
  moduleId: module.id.replace("/dist/", "/"),
  selector: 'ul [pathbar]',
  templateUrl: 'pathbar.html',
  host: { '[class.pathbar]': '\'true\'' }
})
export class Pathbar implements OnInit {
  @Input() fascicolo: FascicoloFull;
  @Input() pratica: PraticaBase;
  private tipoPratica: string;

  constructor(private frontEndMapping: FrontEndMapping) {}

  ngOnInit() {
    this.frontEndMapping.getListTipiPratica(this.pratica.tipoPratica.id).subscribe(res => {
      this.tipoPratica = res; // FrontEndMapping.tipiPratica[this.pratica.tipoPratica.id];
    });
  }

  getPraticaViewPath() {
    return ServicePathsSettings.VIEW_LABEL;
  }
}
